module.exports = __webpack_public_path__ + "img/polygon_box.29ead3ff.svg";